import React, { useEffect, useState } from 'react';
import './TestSummaryPage.scss';
import { useHistory, useParams, useLocation } from 'react-router';
import { Logo } from '../../shared/logo';
import { Button } from '../../components/Button/Button';
import { useStores } from '../../custom-hooks/store/use-stores';
import { AssessmentService, ReportService, TestService } from '../../services';
import { Test, RandomConfig } from '../../types';

export const TestSummary = () => {
  const history = useHistory();
  const { testId } = useParams<any>();
  const [assessments, setAssessments] = useState<Test[]>([]);
  const [currentTest, setCurrentTest] = useState<Test>();
  const [randomQuestionNumber, setRandomQuestionNumber] = useState(0);
  const { search, pathname } = useLocation();
  const [assessmentType, setAssessmentType] = useState('');
  const [isStarting, setIsStarting] = useState(false);

  const {
    userStore: {
      user: { assessment: assessmentId, _id: userId },
    },
  } = useStores();

  const getAssessments = async () => {
    const receivedAssessment = await AssessmentService.getAssessment(assessmentId, { // eslint-disable-line
      params: { candidate: userId },
    });

    setAssessmentType(receivedAssessment.data.assessmentType);

    setAssessments([...(receivedAssessment.data.mandatoryTests || []), ...(receivedAssessment.data.tests || [])]);
  };

  const getCurrentTest = async () => {
    const receivedAssessment = await TestService.getTest(testId);
    const randomQNumber = receivedAssessment.data.randomConfig.reduce((acc: number, object: RandomConfig) => (acc + object.random), 0);
    setRandomQuestionNumber(randomQNumber ? (receivedAssessment.data.questions.length + randomQNumber) : receivedAssessment.data.questions.length);
    setCurrentTest(receivedAssessment.data);
  };

  useEffect(() => {
    getAssessments();
    getCurrentTest();
  }, []);

  const handleTestStart = (id: string) => {
    const foundChosenTest = assessments.find(
      (elem: Test) => elem._id === id,
    );

    if (!foundChosenTest) {
      return;
    }

    const historyPath = pathname.includes('education') ? 'education-tasks' : 'test';

    if (foundChosenTest.report) {
      history.push(
        `/${historyPath}/${id}?report=${foundChosenTest.report._id}`,
      );
      if (!localStorage.getItem(`testStartedTime:${id}${userId}${assessmentId}`)) {
        localStorage.setItem(`testStartedTime:${id}${userId}${assessmentId}`, new Date().getTime().toString());
      }
      return;
    }

    const data = {
      assessment: assessmentId,
      candidate: userId,
      test: `${id}`,
      answers: [],
    };

    setIsStarting(true);
    ReportService.createReport(data)
      .then((res) => {
        localStorage.setItem(`testStartedTime:${id}${userId}${assessmentId}`, new Date().getTime().toString());
        history.push(`/${historyPath}/${id}?report=${res.data._id}`);
      })
      .catch(() => {
        setIsStarting(false);
      });
  };

  return (
    <div className="test-summary-page">
      <div className="test-summary-page__logo">
        <Logo />
      </div>
      <div className="test-summary-page__container">
        <h1>{currentTest && currentTest.name}</h1>
        <div className="test-summary-page__instruction">
          <div>Instruction:</div>
          <ul>
            {/* here is issue */}
            <li>
              Number of questions: <span>{randomQuestionNumber}</span>
            </li>
            <li>
              Questions displayed per page: <span>1</span>
            </li>
            {
              (currentTest && currentTest?.questions.length > 1 && assessmentType !== 'screening') && <li> Will allow you to go back and change your answers.</li>
            }
          </ul>
        </div>
        <div className="start-btn-container">
          <Button
            title={search.includes('isCompleted') ? 'Continue' : 'Start →'}
            onClick={() => handleTestStart(testId)}
            className="start-btn"
            disabled={isStarting}
          />
        </div>
      </div>
    </div>
  );
};
